import { CanvasTexture, SRGBColorSpace } from 'three';

// Canvas-generated soft radial sprite — glow/corona/nebula-puff texture with
// zero asset weight. Cached per (size, stops) signature.
//
// The falloff is BAKED INTO RGB OVER OPAQUE BLACK (alpha=255 everywhere),
// not stored in the alpha channel. Canvas 2D backing stores are
// premultiplied; uploading a straight-alpha texture forces the browser to
// UNPREMULTIPLY, and at low-alpha gradient texels the per-channel rounding
// error creates off-color texels — WebKit's rounding skews green, and those
// texels magnified across a big corona/glow sprite rendered through the
// float postFX pipeline showed up as scattered green specks in Safari
// (Chromium's higher-precision path hid it). With uniform alpha=1 the
// roundtrip is lossless on every engine, and under ADDITIVE blending
// (every consumer of this texture) black adds nothing — visually identical.
const cache = new Map();

export function softSpriteTexture({ size = 256, stops = [[0, 'rgba(255,255,255,1)'], [0.4, 'rgba(255,255,255,0.32)'], [1, 'rgba(255,255,255,0)']] } = {}) {
  const key = `${size}|${JSON.stringify(stops)}`;
  if (cache.has(key)) return cache.get(key);
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, size, size); // opaque base — alpha stays 255 everywhere
  const g = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
  stops.forEach(([offset, color]) => g.addColorStop(offset, color));
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, size, size);
  const texture = new CanvasTexture(canvas);
  texture.colorSpace = SRGBColorSpace;
  cache.set(key, texture);
  return texture;
}
